export type ApiError = Error & { field?: string };

async function request<T>(path: string, init: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: 'include',
    headers: init.body ? { 'Content-Type': 'application/json' } : undefined,
    ...init,
  });
  const text = await response.text();
  if (!response.ok) {
    let message = `Запит не вдався (${response.status})`;
    let field: string | undefined;
    try {
      const envelope = JSON.parse(text) as { error?: string; field?: string };
      if (envelope.error) message = envelope.error;
      field = envelope.field;
    } catch {
      if (text) message = text;
    }
    // field — яке поле форми підсвітити (адмінка товарів).
    throw Object.assign(new Error(message), { field }) as ApiError;
  }
  return text ? (JSON.parse(text) as T) : (undefined as T);
}

export const apiGet = <T>(path: string): Promise<T> => request<T>(path, { method: 'GET' });

export const apiPost = <T>(path: string, body?: unknown): Promise<T> =>
  request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) });

export const apiPatch = <T>(path: string, body?: unknown): Promise<T> =>
  request<T>(path, {
    method: 'PATCH',
    body: body === undefined ? undefined : JSON.stringify(body),
  });

export const apiPut = <T>(path: string, body?: unknown): Promise<T> =>
  request<T>(path, { method: 'PUT', body: body === undefined ? undefined : JSON.stringify(body) });

export const apiDelete = <T>(path: string): Promise<T> => request<T>(path, { method: 'DELETE' });
